export enum WeightUnit {
  Kilogram = 'KG',
  Pound = 'LB'
}

export interface Weight {
  unit: WeightUnit;
  value: number;
}
